import Col from './Col'

Col.install = (Vue, options) => {
  Vue.component(Col.name, Col)
}
export default Col


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/components/Col/index.js
// module id = null
// module chunks = 